import { render, staticRenderFns } from "./directbox-receive.vue?vue&type=template&id=62c45950&"
import script from "./directbox-receive.vue?vue&type=script&lang=js&"
export * from "./directbox-receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c45950')) {
      api.createRecord('62c45950', component.options)
    } else {
      api.reload('62c45950', component.options)
    }
    module.hot.accept("./directbox-receive.vue?vue&type=template&id=62c45950&", function () {
      api.rerender('62c45950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/directbox-receive.vue"
export default component.exports